import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Textarea } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Textarea/Form.tsx
var TextareaFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	return /* @__PURE__ */ jsx(Textarea, {
		error: errorsByFieldId[config.id],
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		label: /* @__PURE__ */ jsx(Fragment$1, { children: config.options.label || config.options.formLabel }),
		onChangeValue: (val) => fieldValueChanged(config.id, val),
		value: valuesByFieldId[config.id],
		name: config.name,
		subText: config.options.subText
	});
};
//#endregion
export { TextareaFieldForm };

//# sourceMappingURL=Form.js.map